<template>
  <div>
    <!-- 从lounge跳转过来 -->
    <ul class="tab-bar-list">
      <li
        v-for="(item, index) in tabBarList"
        @click="handleClickItem(index, item)"
        :class="{ tabBarActive: airportServiceCategoryIndex === index }"
        :key="index"
      >
        {{ $t(item.title) }}
      </li>
    </ul>

    <!-- 搜索结果/过滤 -->
    <div class="tab-bar-filter">
      <div class="infos">
        <p class="title">{{ $t(filterTitle) }}</p>
        <span class="circle">•</span>
        <p class="count">{{ tabSearchLength }} {{ $t('search-box-results') }}</p>
      </div>
      <div class="filters">
        <div
          class="filter-content filter-target"
          :class="{ currentFilter: this.currentItem.length && !filterToolShow }"
          @click="handleLoungeFilter"
        >
          <p class="filter-target">
            <span class="filter-label filter-target"
              >{{ $t('views-lounge-filters') }}
              <span class="filter-target" v-if="this.currentItem.length && !filterToolShow"
                >({{ this.currentItem.length }})</span
              >
            </span>
            <span
              class="filter-count filter-target"
              v-if="this.currentItem.length && !filterToolShow"
              >{{ this.currentItem.length }}</span
            >
          </p>
          <span
            class="filter-target"
            :class="[
              this.currentItem.length && !filterToolShow ? 'filters-light-icon' : 'filters-icon',
            ]"
          ></span>
        </div>

        <!-- Filter弹窗 -->
        <div v-show="filterToolShow" class="fliter-modal">
          <div class="modal-overlay"></div>
          <div v-click-outside="popoverOutsideClick" class="filters-box">
            <div class="filters-header">
              <p class="title">
                {{ $t('views-lounge-filter') }}
                <span v-if="this.currentItem.length">({{ this.currentItem.length }})</span>
              </p>
              <img @click="handleFiltersCancel" src="~img/icon-cancel.svg" alt="cancel" />
            </div>
            <div class="filters-content">
              <div class="filter-switches">
                <div class="filter-switch-row filter-prebooking">
                  <p class="filter-copy">{{ $t('prebooking-filter-desc') }}</p>
                  <Switcher :value="filterPrebookingStatus" @change="handleStatusChange"></Switcher>
                </div>
                <div
                  v-if="itemType === 1 && !airportHasNoAdditionalFee"
                  class="filter-switch-row filter-no-additional-fee"
                >
                  <div class="filter-copy">
                    <p class="filter-title">{{ $t('no-additional-fee-filter-title') }}</p>
                    <p>{{ $t('no-additional-fee-filter-desc') }}</p>
                  </div>
                  <Switcher
                    :value="filterNoAdditionalFeeStatus"
                    @change="handleNoAdditionalFeeStatusChange"
                  ></Switcher>
                </div>
              </div>
              <div class="filters-terminal" v-if="terminalList && terminalList.length">
                <p class="filters-category">{{ $t('search-box-terminal') }}</p>
                <ul>
                  <li
                    v-for="(item, index) in terminalList"
                    :key="index"
                    :class="{ active: currentItem.includes(item) }"
                    @click="handleFilterClick('terminalList', item)"
                  >
                    <p class="filters-checkbox" :class="{ active: currentItem.includes(item) }">
                      <img src="~img/icon-check-white.svg" alt="" />
                    </p>
                    <p>{{ item }}</p>
                  </li>
                </ul>
              </div>
              <div class="filters-terminal" v-if="locationList && locationList.length">
                <p class="filters-category">{{ $t('search-box-location') }}</p>
                <ul>
                  <li
                    v-for="(item, index) in locationList"
                    :key="index"
                    :class="{ active: currentItem.includes(item) }"
                    @click="handleFilterClick('locationList', item)"
                  >
                    <p class="filters-checkbox" :class="{ active: currentItem.includes(item) }">
                      <img src="~img/icon-check-white.svg" alt="" />
                    </p>
                    <p>{{ item }}</p>
                  </li>
                </ul>
              </div>
              <div class="filters-terminal" v-if="securityList && securityList.length">
                <p class="filters-category">{{ $t('search-box-security') }}</p>
                <ul>
                  <li
                    v-for="(item, index) in securityList"
                    :key="index"
                    :class="{ active: currentItem.includes(item) }"
                    @click="handleFilterClick('securityList', item)"
                  >
                    <p class="filters-checkbox" :class="{ active: currentItem.includes(item) }">
                      <img src="~img/icon-check-white.svg" alt="" />
                    </p>
                    <p>{{ item }}</p>
                  </li>
                </ul>
              </div>
            </div>
            <!-- Filter弹窗按钮 -->
            <div class="message-btn-group">
              <button
                class="message-btn"
                :class="{ active: this.currentItem.length || true }"
                role="button"
                @click="handleApplyFilter"
              >
                {{ $t('btn-apply') }}
              </button>
              <button class="message-cancel-btn" role="button" @click="handleResetFilter">
                {{ $t('btn-reset') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="lounge-card-list">
      <cards
        :options="filteredSearchItemData"
        @cardClick="cardClick({ ...$event, searchItemData: filteredSearchItemData })"
      ></cards>
      <p
        v-if="
          airportServiceCategoryIndex === 0 &&
          hasVisibleCards &&
          !filterNoAdditionalFeeStatus &&
          !airportHasNoAdditionalFee
        "
        class="additional-entry-fee"
      >
        <span class="additional-entry-fee-icon" aria-hidden="true">$</span>
        <span>{{ $t('additional-entry-fee-applies') }}</span>
      </p>
      <div
        v-if="
          !filteredSearchItemData.cards.length &&
          loadingStatus[0] === false &&
          loadingStatus[1] === false
        "
        class="no-found"
      >
        <img src="~img/icon-tips.svg" alt="tips" />
        <span v-if="this.currentItem.length && !filterToolShow">
          <span>{{
            $t('airport-result-no-match', [$t(tabBarList[airportServiceCategoryIndex].title)])
          }}</span>
          <br />
          <span
            class="reset-btn"
            @click="
              () => {
                handleResetFilter();
                handleApplyFilter();
              }
            "
          >
            {{ $t('btn-reset') }}
          </span>
        </span>
        <span v-else>{{
          $t('airport-result-no-result', [$t(tabBarList[airportServiceCategoryIndex].title)])
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import Cards from '@/components/BaseUi/AirportLoungeCards';
  import { mapState } from 'vuex';
  import { clickOutside } from '@/utils/directive';
  import Switcher from '@/components/BaseUi/Switch/index.vue';
  // import { arrContainAnotherArr } from '@/utils';

  export default {
    props: {
      fromSearchData: {
        type: Object,
        default: () => {},
      },
      searchItemData: {
        type: Object,
        default: () => {},
      },
      loungeLength: {
        type: Number,
        default: 0,
      },
      firstLoungeLength: {
        type: Number,
        // default: 0,
      },
      diningLength: {
        type: Number,
        default: 0,
      },
      firstDiningLength: {
        type: Number,
        // default: 0,
      },
      retailLength: {
        type: Number,
        default: 0,
      },
      loadingStatus: {
        type: Array,
        default: () => [true, true],
      },
    },

    components: {
      Cards,
      Switcher,
    },

    computed: {
      ...mapState(['airportServiceCategoryIndex']),
      tabSearchLength() {
        if (this.airportServiceCategoryIndex === 0) {
          return this.filterNoAdditionalFeeStatus
            ? this.filteredLoungeCards.length
            : this.loungeLength;
        }
        if (this.airportServiceCategoryIndex === 1) return this.diningLength;
        if (this.airportServiceCategoryIndex === 2) return this.retailLength;
      },

      filteredLoungeCards() {
        return this.searchItemData.cards.filter(card => {
          if (card.fakeElement) return false;
          return card.noAdditionalFee === true || card.noAdditionalFee === 'true';
        });
      },

      filteredSearchItemData() {
        if (this.airportServiceCategoryIndex !== 0 || !this.filterNoAdditionalFeeStatus) {
          return this.searchItemData;
        }

        const cards = [...this.filteredLoungeCards];
        const remainingCards = cards.length % 3;
        const fakeCardCount = remainingCards ? 3 - remainingCards : 0;
        for (let index = 0; index < fakeCardCount; index += 1) {
          cards.push({ fakeElement: true });
        }

        return {
          ...this.searchItemData,
          cards,
        };
      },

      hasVisibleCards() {
        return this.filteredSearchItemData.cards.some(card => !card.fakeElement);
      },

      showFilterBtn() {
        if (this.airportServiceCategoryIndex === 0) {
          if (this.firstLoungeLength > 0 && this.clickFilter) this.matchName = 'no-match-items';
          // if (this.firstLoungeLength > 0) return true;
          this.matchName = 'views-lounge-no-found';
          return true;
        }
        if (this.airportServiceCategoryIndex === 1) {
          if (this.firstDiningLength > 0 && this.clickFilter) this.matchName = 'no-match-items';
          // if (this.firstDiningLength > 0) return true;
          this.matchName = 'views-lounge-no-found';
          return true;
        }
      },
      // showPrebookingFilter() {
      //   const hasBookableLounge = this.searchItemData.cards.some(item => item.bookable === true);
      //   return this.filterTitle === 'lounge' && hasBookableLounge;
      // },
    },

    data() {
      return {
        // currentIndex: 0,
        itemType: 1,
        filterTitle: 'lounge',
        tabBarList: [
          {
            title: 'lounge',
            type: 'lounges',
          },
          {
            title: 'search-dining',
            type: 'dining',
          },
          {
            title: 'search-retail',
            type: 'retail',
          },
        ],
        showNoFound: false,
        matchName: 'views-lounge-no-found',

        filterToolShow: false, // 当前filter弹窗展示/隐藏
        filterList: [], // 当前filter弹窗内部需要展示的数据
        condition: {}, // 当前filter弹窗内部选中的筛选条件
        currentItem: [], // 当前filter弹窗内部选中的item
        tempCondition: {},
        tempCurrentItem: [],
        tempFilterPrebookingStatus: false,
        tempFilterNoAdditionalFeeStatus: false,
        clickFilter: false,
        filterPrebookingStatus: false,
        filterNoAdditionalFeeStatus: false,
        airportHasNoAdditionalFee: false,
        terminalList: [],
        locationList: [],
        securityList: [],
      };
    },

    directives: { clickOutside },
    methods: {
      // computedArrContainAnotherArr() {
      //   return arrContainAnotherArr(this.loadingStatus, [false, false])
      // },
      popoverOutsideClick(e) {
        if (!this.filterToolShow) return;
        if ([...e.target.classList].includes('filter-target')) return;
        this.filterToolShow = false;
        this.condition = JSON.parse(JSON.stringify(this.tempCondition));
        this.currentItem = JSON.parse(JSON.stringify(this.tempCurrentItem));
        this.filterPrebookingStatus = this.tempFilterPrebookingStatus;
        this.filterNoAdditionalFeeStatus = this.tempFilterNoAdditionalFeeStatus;
      },
      isHideFilterOrNot(filterTitle) {
        // if (filterTitle === 'lounge' && this.firstLoungeLength === 0) return false;
        // if (filterTitle === 'search-dining' && this.firstDiningLength === 0) return false;
        // return true;
        if (filterTitle === 'search-retail') return false;
        return true;
      },
      handleCardClick(data) {
        console.log('卡片事件', data);
      },

      handleLoungeFilter() {
        this.filterToolShow = true;
        this.tempCondition = JSON.parse(JSON.stringify(this.condition));
        this.tempCurrentItem = JSON.parse(JSON.stringify(this.currentItem));
        this.tempFilterPrebookingStatus = this.filterPrebookingStatus;
        this.tempFilterNoAdditionalFeeStatus = this.filterNoAdditionalFeeStatus;
        if (this.itemType === 2) {
          !!window.FS &&
            FS.event('Dining_ExploreFilter', {
              timestamp: new Date().getTime(),
              location: this.fromSearchData?.airportCode,
            });
        }
      },

      handleClickItem(index, item) {
        sessionStorage.setItem('airportServiceCategoryIndex', JSON.stringify(index));
        this.$store.commit('setState', {
          state: 'airportServiceCategoryIndex',
          values: index,
        });
        this.filterList = [];

        this.matchName = 'views-lounge-no-found';
        // if (item.type === 'retail') {
        //   this.filterTitle = item.title;
        //   // 清除filter弹窗状态
        //   this.handleResetFilter();
        //   this.$emit('changeTab', item);
        //   return;
        // }

        if (item.type === 'lounges') {
          this.judegeLgAngDin(item, 1);
        } else if (item.type === 'dining') {
          this.judegeLgAngDin(item, 2);
        } else {
          this.judegeLgAngDin(item, 3);
        }
      },

      judegeLgAngDin(item, type) {
        this.itemType = type;
        this.filterTitle = item.title;
        // 清除filter弹窗状态
        // this.handleResetFilter();
        this.$emit('changeTab', type);
        // this.handleGetFilterData(this.fromSearchData, type);
      },

      // filter弹窗过滤后需要存到condition的数据和弹窗li样式规则
      handleFilterClick(listName, item) {
        if (listName in this.condition) {
          const isinner = this.condition[listName].some(res => res === item);
          // 判断是否包含某个值并且移除
          if (isinner) {
            this.condition[listName].splice(
              this.condition[listName].findIndex(i => i === item),
              1,
            );
            // 用于展示filter选中li样式移除
            this.currentItem.splice(
              this.currentItem.findIndex(i => i === item),
              1,
            );
          } else {
            // 判断当前选中的item是不是ALL字段的，是的话则移除当前数组里的其它项，只加入ALL字段的选项
            if (item.indexOf('All') === 0) {
              // 能找到就移除
              this.condition[listName].forEach(str => {
                this.currentItem.splice(
                  this.currentItem.findIndex(i => i === str),
                  1,
                );
              });
              this.condition[listName] = [item];
              this.currentItem.push(item);
              return;
            }

            // 不包含某个值则添加
            this.condition[listName].push(item);
            // 用于展示filter选中li样式添加
            this.currentItem.push(item);

            // 判断condition和currentItem里面是否包含ALL字段的，是的话则移除
            const allStrName = this.condition[listName].find(str => str.indexOf('All') === 0);
            const allStrIndex = this.condition[listName].findIndex(str => str.indexOf('All') === 0);
            if (allStrIndex !== -1) {
              this.condition[listName].splice(allStrIndex, 1);
              this.currentItem = this.currentItem.filter(str => str !== allStrName);
            }
          }
        } else {
          // 首次condition是没有这个listName属性的, 所以直接加上
          this.condition[listName] = [item];
          // 用于展示filter选中li样式添加
          this.currentItem.push(item);
        }
      },

      // filter弹窗关闭按钮
      handleFiltersCancel() {
        this.filterToolShow = false;
        this.condition = JSON.parse(JSON.stringify(this.tempCondition));
        this.currentItem = JSON.parse(JSON.stringify(this.tempCurrentItem));
        this.filterPrebookingStatus = this.tempFilterPrebookingStatus;
        this.filterNoAdditionalFeeStatus = this.tempFilterNoAdditionalFeeStatus;
      },

      // filter弹窗reset按钮
      handleResetFilter() {
        this.condition = {};
        this.currentItem = [];
        this.filterPrebookingStatus = false;
        this.filterNoAdditionalFeeStatus = false;
      },

      // filter弹窗apply按钮
      handleApplyFilter() {
        // if (!this.currentItem.length) {
        //   return;
        // }
        if (this.filterPrebookingStatus) {
          this.condition.bookableList = [true];
        } else {
          this.condition.bookableList = undefined;
        }
        this.filterToolShow = false;
        this.clickFilter = true;
        this.$emit('handleApplyFilter', this.condition, this.itemType);
      },

      // 获取filter数据
      handleGetFilterData(item) {
        this.loadingStatus[1] = true;
        this.airportHasNoAdditionalFee = false;
        this.$loading.show();
        const data = {
          lang: this.$i18n.locale,
          scode: item.airportCode,
          userId: this.$store.state.userInfo?.userId || '',
        };
        this.$http.lounge.getFilterData(data).then(
          res => {
            this.loadingStatus[1] = false;
            if (res.state === '11') {
              const noAdditionalFee = res.payload?.noAdditionalFee ?? res.noAdditionalFee;
              this.airportHasNoAdditionalFee =
                noAdditionalFee === true || noAdditionalFee === 'true';
              if (this.airportHasNoAdditionalFee) {
                this.filterNoAdditionalFeeStatus = false;
                this.tempFilterNoAdditionalFeeStatus = false;
              }
              this.locationList = res.payload?.locationList || [];
              this.securityList = res.payload?.securityList || [];
              this.terminalList = res.payload?.terminalList || [];
              this.$loading.hide();
            } else {
              console.error(res.note);
              this.$loading.hide();
            }
          },
          err => {
            this.loadingStatus[1] = false;
            console.error(err);
            this.$loading.hide();
          },
        );
      },

      // filter接口数据处理
      getFilterListItem(arr) {
        for (const item of arr) {
          let isObj;
          if (item?.valueList) {
            isObj = item.valueList.some(data => typeof data === 'object');
          }

          if (typeof item === 'object' && !isObj) {
            this.filterList.push({
              title: item.title || item.innerTitle,
              valueList: item.valueList || item.innerList,
            });
          }

          if (item.valueList && item.valueList.length) {
            this.getFilterListItem(item.valueList);
          }
        }
      },
      cardClick(data) {
        if (data.searchItemData.type === 1) {
          this.$router.push({
            path: '/lounge/details',
            query: { loungeCode: data.code },
          });
        } else if (data.searchItemData.type === 2) {
          this.$router.push({
            path: '/dining/details',
            query: { diningCode: data.code, diningId: data.id, tagList: data.tagList },
          });
        } else if (data.searchItemData.type === 3) {
          console.log('data', data);
          this.$router.push({
            path: '/retail/details',
            query: { airportCode: data.scode, retailCodes: data.retailCodes },
          });
        }
      },
      handleStatusChange(value) {
        this.filterPrebookingStatus = value;
        // this.condition.bookableList = [value];
      },
      handleNoAdditionalFeeStatusChange(value) {
        this.filterNoAdditionalFeeStatus = value;
      },
    },
    // updated() {
    //   console.log('this.loadingStatus', this.loadingStatus);
    // },
  };
</script>

<style lang="scss" scoped>
  @use './index.scss';
  @use './mobile';
</style>
